import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, readOnly, generated = false, locked = false, emptyValue = "-", value, ...props }, ref) => {
  const isReadOnly = readOnly || generated || locked;
  const displayValue = isReadOnly && (value === "" || value == null) ? emptyValue : value;
  const valueProps = value !== undefined || isReadOnly ? { value: displayValue } : {};
  const fieldState = locked ? "locked" : generated ? "generated" : isReadOnly ? "readonly" : props.disabled ? "disabled" : "editable";
  return (
    <input
      type={type}
      className={cn(
        "field-control flex h-10 w-full rounded-lg border px-3 py-2 text-base shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-45 md:text-sm",
        generated ? "field-generated" : isReadOnly ? "field-readonly" : "field-editable",
        className
      )}
      ref={ref}
      readOnly={isReadOnly}
      aria-readonly={isReadOnly || undefined}
      data-field-state={fieldState}
      {...valueProps}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
